import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
// import TwitterIcon from '@material-ui/icons/Twitter';
import './FooterD5.scss';

const FooterD5 = ({ client }) => {
  const year = new Date().getFullYear();
  const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

  const fb = client?.link_fb || '';
  const ig = client?.link_ig || '';

  return (
    <footer className="d5-footer" role="contentinfo">
      <div className="d5-footer__container">
        <div className="d5-footer__grid">
          {/* Columna: info + redes */}
          <div className="d5-footer__col">
            <h3 className="d5-footer__title">
              {client?.description ? `${client.description} Información` : 'Información'}
            </h3>

            <div className="d5-footer__social">
              {fb ? (
                <a href={fb} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                  <FacebookIcon />
                </a>
              ) : null}
              {ig ? (
                <a href={ig} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <InstagramIcon />
                </a>
              ) : null}
              {/* <a href="#" aria-label="Twitter"><TwitterIcon /></a> */}
            </div>
          </div>

          {/* Columna: Contacto */}
          <div className="d5-footer__col">
            <h3 className="d5-footer__title">Contacto</h3>
            <ul className="d5-footer__list">
              <li><Link to="/contacto">Contacto</Link></li>
              <li><Link to="/contacto">Local</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="d5-footer__bottom">
          <p className="d5-footer__copy">
            © {year} · Derechos reservados por{' '}
            <a
              href="https://info.jaypionba.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="d5-footer__brand"
            >
              Jaypion
            </a>
          </p>

          <button
            className="d5-footer__totop"
            onClick={scrollToTop}
            type="button"
            aria-label="Ir al inicio"
          >
            <span>IR AL INICIO</span>
            <i className="fa fa-arrow-up" aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default FooterD5;
